import { combineReducers, configureStore } from '@reduxjs/toolkit';
import uuid from 'react-uuid';
import filtersReducer from 'slices/FiltersSlice';
import scenarioOneReducer from './slices/ScenarioOneSlice';
import scenarioTwoReducer from './slices/ScenarioTwoSlice';
import scenarioThreeReducer from 'slices/ScenarioThreeSlice';
import scenarioFourReducer from 'slices/ScenarioFourSlice';
import landingReducer from './slices/LandingSlice';
import marketReducer from './slices/MarketSlice';
import teamReducer from './slices/TeamSlice';
import appReducer from './slices/AppSlice';
import rmReducer from './slices/RmSlice';

import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

let windowId = sessionStorage.getItem('my-window-id');
if (!windowId) {
    windowId = uuid(); // Generate a random alphanumeric string
    sessionStorage.setItem('my-window-id', windowId);
}

const storageKey = `root-${windowId}`;
const persistConfig = {
    key: storageKey,
    storage
};

const persistedReducer = persistReducer(
    persistConfig,
    combineReducers({
        app: appReducer,
        filters: filtersReducer,
        landing: landingReducer,
        market: marketReducer,
        team: teamReducer,
        scenarioOne: scenarioOneReducer,
        scenarioTwo: scenarioTwoReducer,
        scenarioThree: scenarioThreeReducer,
        scenarioFour: scenarioFourReducer,
        rm: rmReducer
    })
);
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat()
});

export const persistor = persistStore(store);
